export const COMPLETED_OPACITY = 0.6;
